var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .volume-st0{fill:#FFFFFF;}\n    .volume-st1{fill:none;stroke:#FFFFFF;stroke-width:16.4886;stroke-linecap:round;stroke-miterlimit:10;}\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sound"
  }, /*#__PURE__*/React.createElement("path", {
    className: "volume-st0",
    d: "M159,305.2h-5.2c-8.1,0-14.8-6.6-14.8-14.8v-69c0-8.1,6.6-14.8,14.8-14.8h5.2c8.1,0,14.8,6.6,14.8,14.8v69     C173.8,298.6,167.2,305.2,159,305.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "volume-st0",
    d: "M241.8,336.7l-47.7-28.5c-3.1-1.9-5-5-5-8.3v-87.8c0-3.3,1.9-6.4,5-8.3l47.7-28.5c7.6-4.5,17.9,0.2,17.9,8.3     v144.8C259.6,336.4,249.4,341.2,241.8,336.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "threeLines"
  }, /*#__PURE__*/React.createElement("path", {
    id: "low",
    className: "volume-st1",
    d: "M290.1,241.3c5.1,2.9,8.5,8.4,8.5,14.7s-3.4,11.8-8.5,14.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "medium",
    className: "volume-st1",
    d: "M290.1,201.4c25.5,5.1,44.8,27.6,44.8,54.6s-19.3,49.5-44.8,54.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "high",
    className: "volume-st1",
    d: "M290.1,162.3c46.7,5.7,82.9,45.5,82.9,93.7s-36.2,88-82.9,93.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.2d96d90f1e375dd264f6cb5458dd863e.svg";
export { ForwardRef as ReactComponent };